// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"2449ba7e","319":"dc5da88b","453":"11bc9416","739":"f0d624f6","834":"32ec2f34","863":"4a0e4caa"}[chunkId] + ".chunk.js";
};